import PropTypes from 'prop-types';
import React from 'react';

function Select(props) {
  function onChange(event) {
    props.onChange(event);
  }

  return (
    <div>
      <label className="widget-select-label">{props.label}</label>
      <select
        {...props}
        value={props.value}
        onChange={onChange}
        className="widget-select"
      >
        {props.children}
      </select>
      <span className="widget-select-info info">{props.info}</span>
    </div>
  );
}

Select.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  options: PropTypes.array,
  onChange: PropTypes.func,
  children: PropTypes.any,
  info: PropTypes.string,
};

Select.defaultProps = {
  value: '',
  onChange: () => {},
};

function Option(props) {
  return <option value={props.value}>{props.name}</option>;
}

Option.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
};

Select.Option = Option;

export default Select;
